export default     function focusWithLabel(item) {
  item.querySelector("input").addEventListener("focus", () => {
    item.classList.add("active");
  });
  item.querySelector("input").addEventListener("blur", function () {
    if (this.value.length == 0) {
      item.classList.remove("active");
    }
  });
  let n = 0;
  let oldValue = null;
  item.querySelector("input").addEventListener("input", function (e) {
    let span = item
      .querySelector(".input-item__title")
      .querySelectorAll("span");
    const isDelete = oldValue && e.target.value.length < oldValue.length;
    isDelete ? (n -= 10.7) : (n += 10.7);
    oldValue = e.target.value;
    span[1].style.marginLeft = `${n}px`;
  });
}